import { PublicClientApplication } from "@azure/msal-browser";
import createLink from "./createLink";
import { getToken } from "../../api";

export const createAuthenticatedLink = (baseUrl: string, persistedQueries: boolean, msalClient: PublicClientApplication, msalScopes: string[]) => {
    return createLink({
      uri: baseUrl + "/graphql",
      persistedQueries,
      fetch: async (req: RequestInfo | URL, init?: RequestInit) => {
        let token = await getToken(msalClient, msalScopes);  
        return await fetch(req, {
          ...init,
          headers: {
            ...init?.headers,
            Authorization: `Bearer ${token}`,
          },
        });
      }
    });
  }